import * as React from "react";
import { forwardRef } from "react";
const SvgBulletList = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.00049 6H20.0005M9.00049 12H20.0005M9.00049 18H20.0005M5.00049 6V6.01M5.00049 12V12.01M5.00049 18V18.01", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgBulletList);
export { ForwardRef as ReactComponent };
